// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DocumentCreateResponseModel {
    static getAttributeTypeMap() {
        return DocumentCreateResponseModel.attributeTypeMap;
    }
}
DocumentCreateResponseModel.discriminator = undefined;
DocumentCreateResponseModel.attributeTypeMap = [
    {
        "name": "documentGroupId",
        "baseName": "documentGroupId",
        "type": "number"
    },
    {
        "name": "intakeLayoutId",
        "baseName": "intakeLayoutId",
        "type": "number"
    },
    {
        "name": "documentFileName",
        "baseName": "documentFileName",
        "type": "string"
    },
    {
        "name": "documentLocation",
        "baseName": "documentLocation",
        "type": "string"
    }
];
//# sourceMappingURL=documentCreateResponseModel.js.map